export default "__VITE_ASSET__TPJm_jJq__"